import { FunctionComponent, ReactElement } from "react";
import { Input, InputProps } from "@chakra-ui/react";
import useClaimsToast from "../../../hooks/useToast";

interface DatePickerProps {
	value: string;
	max?: string;
	min?: string;
	disabled?: boolean;
	maxH?: string;

	onDateChange: (newDate: string) => void;
	onDateBlur: () => void;
}

const DatePicker: FunctionComponent<DatePickerProps> = (props: DatePickerProps): ReactElement => {
	const { value, max, min, disabled = false, maxH, onDateChange, onDateBlur } = props;
	const toast = useClaimsToast();

	const handleOnPasteEvent = async (): Promise<void> => {
		let pastedDate: string = await navigator.clipboard.readText();
		try {
			const validDate: Date = new Date(pastedDate);
			onDateChange(validDate.toISOString().split("T")[0]);
		} catch (err) {
			console.error(`Error while parsing pasted date => ${pastedDate}`);
			toast("Error", "Could not parse pasted date. Please ensure the pasted date is in MM-DD-YYYY format", "error");
		}
	};

	return (
		<Input
			type="date"
			value={value}
			max={max}
			min={min}
			maxHeight={maxH}
			onChange={(event) => onDateChange(event.target.value)}
			onBlur={onDateBlur}
			disabled={disabled}
			variant="flushed"
			onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleOnPasteEvent()}
		/>
	);
};

export default DatePicker;
